const normalizeSearchValue = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('pt-BR');

export const filterPromptsBySearch = (prompts, search) => {
  const searchTerm = normalizeSearchValue(search).trim();
  if (!searchTerm) return prompts;

  return prompts.filter(prompt =>
    normalizeSearchValue(
      [
        prompt.name,
        prompt.ai_name,
        prompt.settings?.ai_name,
        prompt.category_label,
        prompt.model?.name,
        prompt.model?.model_id,
        prompt.instructions,
        prompt.user_context,
      ].join(' ')
    ).includes(searchTerm)
  );
};
